import { createSelector } from 'reselect';
import {standardSubjects} from 'utilities/standard-subjects.js';

const getUserSubjects      = (state)  => state.user_subject.entities;
const getUser              = (state) => state.authentication.user;
const getDefaultSubs = () => standardSubjects;

const getUserSubjectWithDefaultSubjects = createSelector(
    [getUserSubjects, getDefaultSubs, getUser],
    (userSubjects, standardSubjects, user) => {

        let userSubjectsArray = userSubjects.allIds.map((userSubjectId, index) => {
            return userSubjects.byId[userSubjectId];
        });

        userSubjectsArray = userSubjectsArray.filter((userSubject) => userSubject.user_id == user.id);

        let combinedList = standardSubjects.map((subject, index) => {

            let subjectsThatExist = userSubjectsArray.find((userSubject) => userSubject.subject.toLowerCase() == subject.subject.toLowerCase()); //find will always return the last object (so we have the highest id)

            if(subjectsThatExist) {

                userSubjectsArray = userSubjectsArray.filter((userSubject) => userSubject.subject.toLowerCase() != subject.subject.toLowerCase())

                return {
                    value: subjectsThatExist.subject,
                    label: subjectsThatExist.subject,
                    id: subjectsThatExist.id,
                    custom: true
                }
            }

            return {
                value: subject.subject,
                label: subject.subject
            }
        });

        //all the items left in userSubjectsArray need to be added to the combined list

        userSubjectsArray = userSubjectsArray.map((userSubject) => {
            return {
                value: userSubject.subject,
                label: userSubject.subject
            }
        });


        return combinedList.concat(userSubjectsArray);
    }
);

export default getUserSubjectWithDefaultSubjects;
